import { render, staticRenderFns } from "./BuyersRanking.vue?vue&type=template&id=9c4879ae&scoped=true&"
import script from "./BuyersRanking.vue?vue&type=script&lang=js&"
export * from "./BuyersRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4879ae",
  null
  
)

export default component.exports